const registry = []

/**
 * Добавление видов в регистр.
 * @param {...View} view Виды.
 */
export const pushToRegistry = view => { registry.push(view) }
